/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;height:100%}.field-set[_ngcontent-%COMP%]{width:100%;height:100%;padding-bottom:5px;border-top:1px solid;border-left:1px solid;border-right:1px solid;border-bottom:0}.legend-title[_ngcontent-%COMP%]{font-size:14px}.grid-container[_ngcontent-%COMP%]{padding:0 10px 10px;border-left:1px solid;border-right:1px solid;border-bottom:1px solid;border-top:0;margin-left:2px}"];
export { styles as styles };
